import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { init } from 'seamscroll/src';
import { onMounted } from 'vue';
export default {
  __name: 'index',
  props: {
    id: {
      type: String,
      default: ''
    },
    classOption: {
      type: Object,
      default: {
        step: 1,
        // 速度
        hoverStop: true,
        // 鼠标停止
        direction: 1 // 0 下 1 上 2 左 3 右
      }
    }
  },

  setup(__props) {
    const props = __props;
    onMounted(() => {
      setTimeout(() => {
        const config = Object.assign({}, {
          dom: document.getElementById(props.id)
        }, props.classOption);
        init(config);
      }, 100);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_renderSlot(_ctx.$slots, "default")]);
    };
  }
};